import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

export default function ArticleGrid() {
  const { t } = useTranslation();

  const articles = [
    // Row 1: Einsteiger Guide (3 cards)
    {
      slug: 'oopbuy-spreadsheet-guide',
      imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimal%20desk%20setup%20with%20laptop%20displaying%20colorful%20spreadsheet%20data%20soft%20cream%20background%20editorial%20photography%20scandinavian%20style%20warm%20natural%20lighting%20modern%20workspace%20with%20notebook%20and%20coffee%20mug%20organized%20composition&width=800&height=533&seq=article-guide-v2-01&orientation=landscape",
      titleKey: 'articles.guide1_title',
      descKey: 'articles.guide1_desc',
      tagKey: 'articles.tag',
      variant: 'image' as const,
    },
    {
      slug: 'oopbuy-spreadsheet-guide',
      imageUrl: '',
      titleKey: 'articles.guide2_title',
      descKey: 'articles.guide2_desc',
      tagKey: 'articles.tag',
      variant: 'accent' as const,
    },
    {
      slug: 'oopbuy-spreadsheet-guide',
      imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20flatlay%20with%20fashion%20items%20notebook%20and%20pen%20on%20soft%20cream%20surface%20warm%20natural%20daylight%20clean%20scandinavian%20aesthetic%20editorial%20product%20photography%20organized%20shopping%20planning%20concept%20neutral%20tones%20simple%20composition&width=800&height=533&seq=article-guide-v2-02&orientation=landscape",
      titleKey: 'articles.guide3_title',
      descKey: 'articles.guide3_desc',
      tagKey: 'articles.tag',
      variant: 'image' as const,
    },
    // Row 2: Shipping Guide (3 cards)
    {
      slug: 'oopbuy-spreadsheet-shipping-guide',
      imageUrl: "https://readdy.ai/api/search-image?query=Clean%20minimal%20cardboard%20boxes%20stacked%20on%20wooden%20table%20near%20bright%20window%20soft%20natural%20daylight%20neutral%20cream%20walls%20scandinavian%20interior%20editorial%20product%20photography%20warm%20tones%20shipping%20packaging%20concept%20organized%20neat%20arrangement&width=800&height=533&seq=article-ship-v2-01&orientation=landscape",
      titleKey: 'articles.shipping1_title',
      descKey: 'articles.shipping1_desc',
      tagKey: 'articles.tag_shipping',
      variant: 'image' as const,
    },
    {
      slug: 'oopbuy-spreadsheet-shipping-guide',
      imageUrl: '',
      titleKey: 'articles.shipping2_title',
      descKey: 'articles.shipping2_desc',
      tagKey: 'articles.tag_shipping',
      variant: 'accent' as const,
    },
    {
      slug: 'oopbuy-spreadsheet-shipping-guide',
      imageUrl: "https://readdy.ai/api/search-image?query=Open%20parcel%20box%20with%20tissue%20paper%20on%20cream%20desk%20near%20window%20natural%20soft%20daylight%20clean%20minimal%20scandinavian%20unboxing%20scene%20editorial%20photography%20warm%20neutral%20tones%20simple%20peaceful%20composition%20lifestyle%20product%20moment&width=800&height=533&seq=article-ship-v2-02&orientation=landscape",
      titleKey: 'articles.shipping3_title',
      descKey: 'articles.shipping3_desc',
      tagKey: 'articles.tag_shipping',
      variant: 'image' as const,
    },
    // Row 3: QC Guide (3 cards)
    {
      slug: 'oopbuy-spreadsheet-qc-guide',
      imageUrl: "https://readdy.ai/api/search-image?query=Clean%20workspace%20with%20magnifying%20glass%20fabric%20swatches%20checklist%20clipboard%20on%20soft%20cream%20desk%20natural%20daylight%20scandinavian%20minimal%20editorial%20photography%20warm%20neutral%20tones%20quality%20inspection%20concept%20organized%20professional%20composition&width=800&height=533&seq=article-qc-v2-01&orientation=landscape",
      titleKey: 'articles.qc1_title',
      descKey: 'articles.qc1_desc',
      tagKey: 'articles.tag_qc',
      variant: 'image' as const,
    },
    {
      slug: 'oopbuy-spreadsheet-qc-guide',
      imageUrl: '',
      titleKey: 'articles.qc2_title',
      descKey: 'articles.qc2_desc',
      tagKey: 'articles.tag_qc',
      variant: 'accent' as const,
    },
    {
      slug: 'oopbuy-spreadsheet-qc-guide',
      imageUrl: "https://readdy.ai/api/search-image?query=Minimal%20product%20inspection%20scene%20with%20white%20gloves%20measuring%20tape%20and%20garment%20on%20soft%20cream%20surface%20natural%20daylight%20clean%20scandinavian%20editorial%20photography%20warm%20neutral%20tones%20quality%20checking%20concept%20detailed%20organized%20layout&width=800&height=533&seq=article-qc-v2-02&orientation=landscape",
      titleKey: 'articles.qc3_title',
      descKey: 'articles.qc3_desc',
      tagKey: 'articles.tag_qc',
      variant: 'image' as const,
    },
    // Row 4: Vergleich (3 cards)
    {
      slug: 'oopbuy-spreadsheet-vergleich',
      imageUrl: "https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20tablet%20and%20smartphone%20side%20by%20side%20on%20light%20cream%20wooden%20desk%20showing%20different%20interface%20layouts%20natural%20daylight%20scandinavian%20minimal%20editorial%20photography%20warm%20neutral%20tones%20technology%20comparison%20concept%20clean%20organized&width=800&height=533&seq=article-cmp-v2-01&orientation=landscape",
      titleKey: 'articles.compare1_title',
      descKey: 'articles.compare1_desc',
      tagKey: 'articles.tag_compare',
      variant: 'image' as const,
    },
    {
      slug: 'oopbuy-spreadsheet-vergleich',
      imageUrl: '',
      titleKey: 'articles.compare2_title',
      descKey: 'articles.compare2_desc',
      tagKey: 'articles.tag_compare',
      variant: 'accent' as const,
    },
    {
      slug: 'oopbuy-spreadsheet-vergleich',
      imageUrl: "https://readdy.ai/api/search-image?query=Two%20notebooks%20with%20comparison%20charts%20side%20by%20side%20on%20soft%20cream%20desk%20natural%20daylight%20clean%20scandinavian%20minimal%20editorial%20photography%20warm%20neutral%20tones%20analytics%20concept%20organized%20spreadsheets%20detailed%20layout%20professional%20composition&width=800&height=533&seq=article-cmp-v2-02&orientation=landscape",
      titleKey: 'articles.compare3_title',
      descKey: 'articles.compare3_desc',
      tagKey: 'articles.tag_compare',
      variant: 'image' as const,
    },
  ];

  return (
    <section className="py-20 md:py-28 px-4 md:px-8 lg:px-20 bg-background-50">
      <div className="flex flex-col lg:flex-row lg:items-end gap-4 mb-14">
        <div>
          <p className="text-sm text-foreground-400 font-semibold uppercase tracking-wider mb-2">
            {t('articles.eyebrow')}
          </p>
          <h2 className="text-[40px] md:text-[52px] font-heading italic text-foreground-950 font-normal leading-tight">
            {t('articles.title')}
          </h2>
        </div>
        <p className="text-sm md:text-base text-foreground-600 lg:w-[75%] leading-relaxed">
          {t('articles.desc')}
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {articles.map((article, idx) => {
          if (article.variant === 'accent') {
            return (
              <Link
                key={idx}
                to={`/artikel/${article.slug}`}
                className="group rounded-[20px] overflow-hidden bg-foreground-950 p-8 flex flex-col justify-between min-h-[360px] transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
              >
                <div>
                  <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-foreground-950 text-xs font-semibold mb-5">
                    {t(article.tagKey)}
                  </span>
                  <h3 className="text-xl md:text-[20px] font-heading font-bold text-white leading-[1.4] mb-3">
                    {t(article.titleKey)}
                  </h3>
                  <p className="text-sm text-white/60 leading-relaxed">
                    {t(article.descKey)}
                  </p>
                </div>
                <div className="flex items-center gap-2 text-primary-400 text-sm font-medium mt-6">
                  <span>{t('articles.read_more')}</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </Link>
            );
          }

          return (
            <Link
              key={idx}
              to={`/artikel/${article.slug}`}
              className="group rounded-[20px] overflow-hidden bg-background-100 transition-transform duration-300 hover:-translate-y-1 cursor-pointer"
            >
              <div className="h-[200px] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={t(article.titleKey)}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6">
                <span className="inline-block px-3 py-1 rounded-full bg-primary-500 text-foreground-950 text-xs font-semibold mb-3">
                  {t(article.tagKey)}
                </span>
                <h3 className="text-[20px] font-heading font-bold text-foreground-950 leading-[1.4] mb-2">
                  {t(article.titleKey)}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {t(article.descKey)}
                </p>
                <div className="flex items-center gap-2 text-primary-600 text-sm font-medium mt-4">
                  <span>{t('articles.read_more')}</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}